import { render, staticRenderFns } from "./ButtonBar.vue?vue&type=template&id=1acb461b&scoped=true&"
import script from "./ButtonBar.vue?vue&type=script&lang=js&"
export * from "./ButtonBar.vue?vue&type=script&lang=js&"
import style0 from "./ButtonBar.vue?vue&type=style&index=0&id=1acb461b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acb461b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
